import { I as n } from "../../../iconLoader.gen-iP3mpNfl.js";
async function s(e) {
  if (typeof e != "string" || !(e in n)) {
    console.error("Invalid icon name:", e);
    return;
  }
  try {
    const t = await n[e](), o = new DOMParser(), a = new XMLSerializer(), r = o.parseFromString(t.default, "image/svg+xml").documentElement;
    if (r.tagName !== "svg")
      throw new Error("Loaded icon is not an SVG element");
    return r.setAttribute("role", "presentation"), r.setAttribute("aria-hidden", "true"), a.serializeToString(r);
  } catch (t) {
    console.error("Failed to load icon:", e, t);
  }
}
export {
  s as loadIcon
};
//# sourceMappingURL=index.js.map
